export interface Faq {
  id: string;
  q: string;
  a: string;
  group: string;
}

export const faqs: Faq[] = [
  {
    id: 'f1',
    q: '韩国免费漫画到底在哪里可以免费看？',
    a: '可以通过我们整理的资源导航页，找到收录了日更无遮拦韩漫的聚合网站与APP入口。这类站点通常提供网页端与APP两种方式，网页端浏览器打开即看，APP端则支持缓存离线阅读，均无需付费即可观看大量连载与完结作品。',
    group: '资源入口',
  },
  {
    id: 'f2',
    q: '什么叫做"日更无遮拦"？',
    a: '"日更"指作品每天都会更新新内容，让你每天都有新漫画可看；"无遮拦"指阅读版本不做画面遮挡或打码，尽可能保留原作完整内容。合起来就是"每天更新且保留完整画面的韩国漫画"。',
    group: '阅读概念',
  },
  {
    id: 'f3',
    q: '网页端和APP端有什么区别？选哪个更好？',
    a: '网页端无需安装、打开即看，适合临时阅读；APP端支持缓存离线、追更提醒与多源切换，适合长期追更的手机党。两者各有优势，建议根据阅读习惯选择，也可搭配使用。',
    group: '资源入口',
  },
  {
    id: 'f4',
    q: '看到一半作品突然看不了了怎么办？',
    a: '这类情况通常是资源站临时维护或线路切换导致。可以先刷新页面或切换备用线路；若仍无法观看，可在资源导航页换一个同类站点继续阅读，我们的目录收录了多个备选入口。',
    group: '使用问题',
  },
  {
    id: 'f5',
    q: '网站会更新新作和连载吗？更新频率如何？',
    a: '会的。我们持续跟踪韩国免费漫画的新作与连载动态，热门作品基本保持日更同步，同时会定期整理完结作品的全集资源，确保资源导航的时效性。',
    group: '阅读概念',
  },
  {
    id: 'f6',
    q: '无遮拦内容是否有年龄限制？',
    a: '无遮拦版本通常面向成年读者。请根据自身情况理性选择阅读内容，未成年人应在监护人指导下使用，我们同样提倡健康、适度的阅读习惯。',
    group: '使用问题',
  },
  {
    id: 'f7',
    q: '手机阅读体验卡顿，有什么优化建议？',
    a: '可以优先使用APP端并开启缓存离线阅读；网页端可尝试切换画质为"标准"或"流畅"模式，并关闭后台多余应用释放内存。多线路站点也可以尝试切换到更流畅的线路。',
    group: '使用问题',
  },
  {
    id: 'f8',
    q: '想找特定题材的韩漫，应该怎么搜索？',
    a: '你可以在资源导航页或阅读站内使用分类与搜索功能，按"言情""奇幻""热血""校园"等题材筛选；也可以参考我们整理的题材科普文章，先明确自己的口味再精准挑选。',
    group: '阅读概念',
  },
];